import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { SearchOutlined } from "@ant-design/icons";
import { Table } from "antd";
import axios from "axios";
const LL33table = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const localData = JSON.parse(localStorage.getItem("selectedproperties"));
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetchData();
  }, []);


 
 
  const fetchData = async () => {
    setLoading(true);
    try {
      const promises = localData.map(async (v) => {
        if (v.boro) {
          console.log("vvvvvvvvvvvv", v.boro);
          const response = await axios.get(
            `https://data.cityofnewyork.us/resource/355w-xvp2.json?boroughname=${v.boro}`
          );
          console.log(response);
          return response.data;
        }
      });
      const responseData = await Promise.all(promises);
      setData(responseData.flat()); 
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  





  const columns = [
    {
      title: " Building Class",
      dataIndex: "building_class",
    },
    {
      title: "Address",
      dataIndex: "address",

    
    },
    {
      title: "Construction Floors",
      dataIndex: "total_construction_floor",
    },
    {
      title: "Letter Score",
      dataIndex: "energy_star_score",
   
      
    },
    {
      title: "Status",
      dataIndex: "filing_status",
      render: () => (
        <div
          onClick={() => navigate("/corrections_view")}
          style={{ color: "black", cursor: "pointer", display: "flex" }}
        >
          <SearchOutlined className="icons-documentation1" />
        </div>
      ),
      
    },
    
  ];
  return (
    <>
      <div style={{ padding: "20px" }}>
        <Table columns={columns} dataSource={data} size="middle" />
      </div>
    </>
  );
};

export default LL33table;
